import { Markdown } from '@/ui';
import { Section, SectionHeader } from './Section';
import { IAccordionSectionEntry } from '../../../../contentful';
import {
	Accordion,
	AccordionItem,
} from '../../../../components/common/accordion';
import { getListedEntryKey } from '../../../../utils/getListedEntryKey';

export interface IAccordionSectionProps {
	section: IAccordionSectionEntry;
}

export function AccordionSection({ section }: IAccordionSectionProps) {
	return (
		<Section>
			{section.fields.title && (
				<SectionHeader>{section.fields.title}</SectionHeader>
			)}
			<Accordion>
				{section.fields.items &&
					section.fields.items.map((item, index) => (
						<AccordionItem
							key={getListedEntryKey(item, index)}
							title={item.fields.title}
							reverseIcon
						>
							<Markdown source={item.fields.body} />
						</AccordionItem>
					))}
			</Accordion>
		</Section>
	);
}
